import { create } from 'zustand';

interface PaletteState {
  open: boolean;
  query: string;
  setOpen: (open: boolean) => void;
  toggle: () => void;
  setQuery: (query: string) => void;
  close: () => void;
}

export const usePaletteStore = create<PaletteState>(set => ({
  open: false,
  query: '',
  setOpen: open => set({ open, query: open ? '' : '' }),
  toggle: () => set(state => ({ open: !state.open, query: '' })),
  setQuery: query => set({ query }),
  close: () => set({ open: false, query: '' }),
}));

export const paletteStore = usePaletteStore;
